var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.relatives
    ? _c(
        "div",
        [
          _vm.data
            ? _c(
                "div",
                [
                  _c("Top"),
                  _vm._v(" "),
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-sm",
                          class: { "order-2": _vm.isPhoneMediaQuery }
                        },
                        [
                          !_vm.isPhoneMediaQuery
                            ? _c("div", { staticClass: "clearfix m-b-100" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._m(0)
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-6",
                          class: { "order-1": _vm.isPhoneMediaQuery }
                        },
                        [
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: require("@/assets/img/heart.svg?data"),
                              alt: "Ett FH hjärta"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "header-wrapper" }, [
                            _c("div", { staticClass: "clearfix" }),
                            _vm._v(" "),
                            _c("h4", {
                              staticClass: "text-primary-fh welcome-header-h4",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.familytreedashboard.welcomeHeader
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "h4",
                              {
                                staticClass: "text-primary-fh welcome-header-h4"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.toTitleCase(_vm.fullname)) + "!"
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.familytreedashboard.infoText
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "justify-content-center" }, [
                            _vm._v(
                              "\n            Efter att du fyllt i någon släkting så skickar du meddelande\n            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "text-primary-fh text-center cursor",
                                on: {
                                  click: function($event) {
                                    return _vm.goToMessageBtn()
                                  }
                                }
                              },
                              [_c("b", [_vm._v("här")])]
                            ),
                            _vm._v(".\n          ")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _vm.finishedSections === _vm.getRelationshipSections
                            ? _c(
                                "label",
                                {
                                  staticClass: "text-primary-fh larger-text",
                                  attrs: { for: "progress" }
                                },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      "\n              Alla släktgrenar ifyllda!\n            "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.finishedSections !== _vm.getRelationshipSections
                            ? _c(
                                "label",
                                {
                                  staticClass: "text-primary-fh",
                                  attrs: { for: "progress" }
                                },
                                [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.finishedSections
                                        )
                                      }
                                    }),
                                    _vm._v(" av\n              "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.getRelationshipSections
                                        )
                                      }
                                    }),
                                    _vm._v(
                                      " valfria sektioner ifyllda\n            "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "progress" }, [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: {
                                width:
                                  (_vm.finishedSections /
                                    _vm.getRelationshipSections) *
                                    100 +
                                  "%"
                              },
                              attrs: {
                                role: "progressbar",
                                "aria-valuenow": "0",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.familytreedashboard.infoDisclaimer
                              )
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-sm",
                          class: { "order-3": _vm.isPhoneMediaQuery }
                        },
                        [
                          _vm.childrenUnder13TestResults &&
                          _vm.childrenUnder13TestResults.length > 0
                            ? _c("div", [
                                _c("div", { staticClass: "clearfix m-b-100" }),
                                _vm._v(" "),
                                _vm._m(1),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Välj barn för att se information och ta del av ditt barns resultat"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass: "form-control",
                                    on: {
                                      change: function($event) {
                                        return _vm.routeToDashboardMinor($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("- Välj minderårigt barn -")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.childrenUnder13TestResults,
                                      function(child, i) {
                                        return _c(
                                          "option",
                                          {
                                            key: i,
                                            domProps: { value: child.personId }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  child.firstName +
                                                    " " +
                                                    child.lastName
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.childrenUnder13 && _vm.childrenUnder13.length > 0
                            ? _c("div", [
                                _c("div", { staticClass: "clearfix m-b-100" }),
                                _vm._v(" "),
                                !_vm.hasConsentToBeGivenBelow13
                                  ? _c(
                                      "h5",
                                      {
                                        staticClass: "text-primary-fh text-left"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Du har gett samtycke åt samtliga barn under (<13 år) ✓\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasConsentToBeGivenBelow13
                                  ? _c(
                                      "h5",
                                      { staticClass: "text-danger text-left" },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "Du behöver ge samtycke åt dina barn (<13 år)"
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.hasConsentToBeGivenBelow13
                                  ? _c(
                                      "small",
                                      { staticClass: "text-consent-choices" },
                                      [
                                        _vm._v(
                                          "\n              I listan nedan ser du vilka samtyckesval du gjort.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasConsentToBeGivenBelow13
                                  ? _c(
                                      "small",
                                      { staticClass: "text--consent--choices" },
                                      [
                                        _vm._v(
                                          "\n              I listan nedan ser du vilka barn som är i behov av din uppmärksamhet. "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n              Är ett barn markerat med "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v("röd text")]
                                        ),
                                        _vm._v(
                                          " så återstår ett eller fler samtycke. "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n              Är ett barn markerat med "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [_vm._v("grön text")]
                                        ),
                                        _vm._v(
                                          " så är båda samtycken utförda.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass: "form-control",
                                    on: {
                                      change: function($event) {
                                        return _vm.routeToConsentMinor($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("- Välj barn -")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.childrenUnder13, function(
                                      child,
                                      i
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: i,
                                          class: [
                                            _vm.getConsentStatus(child) ===
                                            "consent-to-give-finished"
                                              ? "text-success"
                                              : "",
                                            _vm.getConsentStatus(child) ===
                                            "consent-to-give-remains"
                                              ? "text-danger"
                                              : ""
                                          ],
                                          domProps: { value: child.personId }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                child.firstName +
                                                  " " +
                                                  child.lastName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.childrenBetween13And15 &&
                          _vm.childrenBetween13And15.length > 0
                            ? _c("div", [
                                _c("div", { staticClass: "clearfix m-b-100" }),
                                _vm._v(" "),
                                !_vm.hasConsentToBeGivenAbove13
                                  ? _c(
                                      "h5",
                                      {
                                        staticClass: "text-primary-fh text-left"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Du har gett samtycke åt samtliga barn (13-15 år) ✓\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasConsentToBeGivenAbove13
                                  ? _c(
                                      "h5",
                                      { staticClass: "text-danger text-left" },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "Du behöver ge samtycke åt dina barn (13-15 år)"
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.hasConsentToBeGivenAbove13
                                  ? _c(
                                      "small",
                                      { staticClass: "text-consent-choices" },
                                      [
                                        _vm._v(
                                          "\n              I listan nedan ser du vilka samtyckesval du gjort.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasConsentToBeGivenAbove13
                                  ? _c(
                                      "small",
                                      { staticClass: "text--consent--choices" },
                                      [
                                        _vm._v(
                                          "\n              I listan nedan ser du vilka barn som är i behov av din uppmärksamhet. "
                                        ),
                                        _c("br"),
                                        _vm._v(
                                          "\n              Är ett barn markerat med "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-danger" },
                                          [_vm._v("röd text")]
                                        ),
                                        _vm._v(" så behövs samtycke. "),
                                        _c("br"),
                                        _vm._v(
                                          "\n              Är ett barn markerat med "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "text-success" },
                                          [_vm._v("grön text")]
                                        ),
                                        _vm._v(
                                          " så är samtycke utfört.\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass: "form-control",
                                    on: {
                                      change: function($event) {
                                        return _vm.routeToConsentMinor($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("- Välj barn -")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(_vm.childrenBetween13And15, function(
                                      child,
                                      i
                                    ) {
                                      return _c(
                                        "option",
                                        {
                                          key: i,
                                          class: [
                                            _vm.getConsentStatus(child) ===
                                            "consent-to-give-finished"
                                              ? "text-success"
                                              : "",
                                            _vm.getConsentStatus(child) ===
                                            "consent-to-give-remains"
                                              ? "text-danger"
                                              : ""
                                          ],
                                          domProps: { value: child.personId }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                child.firstName +
                                                  " " +
                                                  child.lastName
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard.parentsHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("parents").length > 0
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type: _vm.relationships.parents
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("parents").length === 0
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type: _vm.relationships.parents
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("parents"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection("parents")
                                          .length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard.childrenHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("children").length > 0 ||
                              _vm.nochildren
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type: _vm.relationships.children
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("children").length === 0 &&
                              !_vm.nochildren
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type: _vm.relationships.children
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nochildren
                                ? _c("p", { staticClass: "text-muted" }, [
                                    _c("i", [_vm._v("Inga barn")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("children"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection("children")
                                          .length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _vm.childrenUnder13State &&
                        _vm.childrenUnder13Consent === true
                          ? _c(
                              "div",
                              { staticClass: "card hasChildrenUnder13-card" },
                              [_vm._m(2)]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.childrenUnder13State &&
                        _vm.childrenUnder13Consent === false
                          ? _c(
                              "div",
                              { staticClass: "card hasChildrenUnder13-card" },
                              [_vm._m(3)]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard.siblingsHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("siblings").length > 0 ||
                              _vm.nosiblings
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type: _vm.relationships.siblings
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("siblings").length === 0 &&
                              !_vm.nosiblings
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type: _vm.relationships.siblings
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nosiblings
                                ? _c("p", { staticClass: "text-muted" }, [
                                    _c("i", [_vm._v("Inga syskon")])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("siblings"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection("siblings")
                                          .length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .motherhalfsiblingsHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("motherhalfsiblings")
                                .length > 0 || _vm.nomotherhalfsiblings
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type:
                                              _vm.relationships
                                                .motherhalfsiblings
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("motherhalfsiblings")
                                .length === 0 && !_vm.nomotherhalfsiblings
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type:
                                              _vm.relationships
                                                .motherhalfsiblings
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nomotherhalfsiblings
                                ? _c("p", { staticClass: "text-muted" }, [
                                    _c("i", [
                                      _vm._v("Inga halvsyskon på mammas sida")
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("motherhalfsiblings"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection(
                                          "motherhalfsiblings"
                                        ).length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .fatherhalfsiblingsHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("fatherhalfsiblings")
                                .length > 0 || _vm.nofatherhalfsiblings
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type:
                                              _vm.relationships
                                                .fatherhalfsiblings
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("fatherhalfsiblings")
                                .length === 0 && !_vm.nofatherhalfsiblings
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type:
                                              _vm.relationships
                                                .fatherhalfsiblings
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nofatherhalfsiblings
                                ? _c("p", { staticClass: "text-muted" }, [
                                    _c("i", [
                                      _vm._v("Inga halvsyskon på pappas sida")
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("fatherhalfsiblings"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection(
                                          "fatherhalfsiblings"
                                        ).length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .mothercousinsHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("mothercousins").length >
                                0 || _vm.nomothercousins
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type:
                                              _vm.relationships.mothercousins
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("mothercousins").length ===
                                0 && !_vm.nomothercousins
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type:
                                              _vm.relationships.mothercousins
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nomothercousins
                                ? _c("p", { staticClass: "text-muted" }, [
                                    _c("i", [
                                      _vm._v(
                                        "Inga syskon samt kusiner på mammas sida"
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("mothercousins"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection("mothercousins")
                                          .length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card" }, [
                          _c(
                            "div",
                            { staticClass: "card-body" },
                            [
                              _c("h5", {
                                staticClass:
                                  "card-title text-primary-fh text-left",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .fathercousinsHeader
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.relativesBySection("fathercousins").length >
                                0 || _vm.nofathercousins
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary change-btn btn-sm",
                                      attrs: {
                                        to: {
                                          name: "ftchange",
                                          params: {
                                            type:
                                              _vm.relationships.fathercousins
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Ändra\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.relativesBySection("fathercousins").length ===
                                0 && !_vm.nofathercousins
                                ? _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "btn btn-primary btn-block btn-lg fill-in-btn",
                                      attrs: {
                                        to: {
                                          name: "ftbuild",
                                          params: {
                                            type:
                                              _vm.relationships.fathercousins
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Fyll i\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.nofathercousins
                                ? _c("p", { staticClass: "text-muted" }, [
                                    _c("i", [
                                      _vm._v(
                                        "Inga syskon samt kusiner på pappas sida"
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.relativesBySection("fathercousins"),
                                  function(relative, i) {
                                    return _c(
                                      "div",
                                      { key: i, staticClass: "col-lg-6" },
                                      [
                                        _vm.relativesBySection("fathercousins")
                                          .length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "text-left" },
                                              [
                                                _c("h6", {
                                                  staticClass: "text-muted",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.kinshipType(
                                                        relative.familyRelation
                                                      )
                                                    )
                                                  }
                                                }),
                                                _vm._v(" "),
                                                relative.familyTreeParentNode !==
                                                null
                                                  ? _c("h6", {
                                                      staticClass:
                                                        "text-muted smaller-h6",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getParentNodeName(
                                                            relative.familyTreeParentNode
                                                          )
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass: "text-dark",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasAcceptedInvite(
                                                  relative
                                                ) &&
                                                !_vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text-success text--relative",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.hasPassedAway(relative)
                                                  ? _c("strong", {
                                                      staticClass:
                                                        "text dark passed-away",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          relative.firstName +
                                                            " " +
                                                            relative.lastName
                                                        )
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-6",
                          attrs: { id: "col-invite-disclaimer" }
                        },
                        [
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.finishedSections === 0
                            ? _c("h4", {
                                staticClass: "text-primary-fh",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .inviterelativesheader
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.numberOfRelativesInvited !== _vm.relatives.length
                            ? _c(
                                "label",
                                {
                                  staticClass: "text-primary-fh",
                                  attrs: { for: "progress" }
                                },
                                [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.numberOfRelativesInvited
                                        )
                                      }
                                    }),
                                    _vm._v(" av\n              "),
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.relatives.length
                                        )
                                      }
                                    }),
                                    _vm._v(" släktingar inbjudna\n            ")
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.relatives.length !== 0 &&
                          _vm.numberOfRelativesInvited === _vm.relatives.length
                            ? _c(
                                "label",
                                {
                                  staticClass: "text-primary-fh",
                                  attrs: { for: "progress" }
                                },
                                [
                                  _c("strong", { staticClass: "larger-text" }, [
                                    _vm._v(
                                      "\n              Alla släktingar inbjudna!\n            "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "progress" }, [
                            _c("div", {
                              staticClass: "progress-bar",
                              style: {
                                width:
                                  (_vm.numberOfRelativesInvited /
                                    _vm.relatives.length) *
                                    100 +
                                  "%"
                              },
                              attrs: {
                                role: "progressbar",
                                "aria-valuenow": "0",
                                "aria-valuemin": "0",
                                "aria-valuemax": "100"
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.finishedSections === 0
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .inviterelativesemptytext
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.finishedSections !== 0
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.familytreedashboard
                                      .inviterelativestext
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _vm.finishedSections !== 0
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "btn btn-primary btn-block btn-lg",
                                  attrs: { to: "/invite" }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.data.familytree.newinviteHeader
                                      ) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm" })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.data
                    ? _c(
                        "div",
                        {
                          staticClass: "modal fade wrapper-margin-top",
                          attrs: {
                            id: "relativeModal",
                            role: "dialog",
                            "aria-labelledby": "relativeModalLabel",
                            "aria-hidden": "true"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "modal-dialog",
                              attrs: { role: "document" }
                            },
                            [
                              _c("div", { staticClass: "modal-content" }, [
                                _c("div", { staticClass: "modal-header" }, [
                                  _vm.prevRelativeData
                                    ? _c(
                                        "h5",
                                        {
                                          staticClass: "modal-title",
                                          attrs: { id: "relativeModalLabel" }
                                        },
                                        [
                                          _vm._v(
                                            "\n            Din tidigare släktinginformation\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._m(4)
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "modal-body" }, [
                                  _vm.prevRelativeData.length === 0
                                    ? _c(
                                        "div",
                                        { staticClass: "register-card" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-body" },
                                            [
                                              _vm._v(
                                                "\n              Vänligen vänta medan data laddas..\n            "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.prevRelativeData &&
                                  _vm.prevRelativeData.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "register-card" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "card-body w-break",
                                              attrs: { id: "prevRelativeData" }
                                            },
                                            [
                                              _vm.prevRelativeData[0]
                                                ? _c("div", [
                                                    _vm.prevRelativeData[0]
                                                      .patientText
                                                      ? _c("div", [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "text-left font-weight-bold"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Blodprovsbedömning:"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .prevRelativeData[0]
                                                                  .patientText
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("hr")
                                                        ])
                                                      : _vm._e()
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.prevRelativeData[1] &&
                                              !_vm.isGeneNegative
                                                ? _c("div", [
                                                    _c(
                                                      "h5",
                                                      {
                                                        staticClass:
                                                          "text-left font-weight-bold"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Genetiskt test:"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.prevRelativeData[1]
                                                      .diagnosisDate
                                                      ? _c("p", [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                _vm.prevRelativeData[1].diagnosisDate.substring(
                                                                  0,
                                                                  10
                                                                )
                                                              ) +
                                                              "\n                  "
                                                          )
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .prevRelativeData[1]
                                                            .diagnosisLocation
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .prevRelativeData[1]
                                                            .mutation
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm
                                                            .prevRelativeData[1]
                                                            .mutationLong
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("hr")
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.prevRelativeData[2]
                                                ? _c("div", [
                                                    _vm.prevRelativeData[2]
                                                      .patientText
                                                      ? _c("div", [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "text-left font-weight-bold"
                                                            },
                                                            [_vm._v("Beslut:")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .prevRelativeData[2]
                                                                  .patientText
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("hr")
                                                        ])
                                                      : _vm._e()
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.prevRelativeData[3]
                                                ? _c("div", [
                                                    _vm.prevRelativeData[3]
                                                      .decisionText
                                                      ? _c("div", [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "text-left font-weight-bold"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Beslut (kardiologpatient):"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .prevRelativeData[3]
                                                                  .decisionText
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("hr")
                                                        ])
                                                      : _vm._e()
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.prevRelativeData[4] &&
                                              _vm.prevRelativeData[4].length > 0
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "h5",
                                                        {
                                                          staticClass:
                                                            "text-left font-weight-bold"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Dina svar på screeningfrågor:"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.prevRelativeData[4],
                                                        function(scr, i) {
                                                          return _c(
                                                            "div",
                                                            { key: i },
                                                            [
                                                              _c("p", [
                                                                _vm._v(
                                                                  "\n                      " +
                                                                    _vm._s(
                                                                      scr.question
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n                      ➢ " +
                                                                    _vm._s(
                                                                      scr.answer
                                                                    ) +
                                                                    "\n                      "
                                                                ),
                                                                scr.eggs
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          scr
                                                                            .eggs
                                                                            .answer
                                                                        )
                                                                      )
                                                                    ])
                                                                  : _vm._e()
                                                              ])
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _vm._m(5)
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("Bottom")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "vue-cookie-accept-decline",
            {
              ref: "cookies",
              attrs: {
                elementId: "cookies",
                debug: false,
                position: "bottom-left",
                type: "floating",
                disableDecline: true,
                transitionName: "slideFromBottom",
                showPostponeButton: false
              }
            },
            [
              _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                _vm._v("\n      Denna sida använder cookies. "),
                _c("br"),
                _vm._v("\n      Läs mer "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.pts.se/cookies",
                      target: "_blank"
                    }
                  },
                  [_vm._v("här")]
                ),
                _vm._v(".\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "acceptContent" }, slot: "acceptContent" },
                [_vm._v("Jag förstår")]
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-left border--emphasize" }, [
      _vm._v(
        "\n            Tidigare släkting? Ta del av din information\n            "
      ),
      _c("strong", [
        _c(
          "a",
          {
            attrs: {
              href: "",
              "data-toggle": "modal",
              "data-target": "#relativeModal"
            }
          },
          [_vm._v("här")]
        )
      ]),
      _vm._v(".\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h5", { staticClass: "text-primary-fh text-left" }, [
      _c("strong", [_vm._v("För dig med barn <13 år.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("small", { staticClass: "hasChildrenUnder13-small" }, [
        _vm._v(
          "\n              Har barn <13 år och gett samtycke till\n              att bli kontaktad av person inom vården för screening av barn. ✓\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _c("small", { staticClass: "hasChildrenUnder13-small" }, [
        _vm._v(
          "\n              Har barn <13 år (ej lämnat samtycke till screening av barn)\n              "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: { type: "button", title: "Logga ut", "data-dismiss": "modal" }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button", "data-dismiss": "modal" }
        },
        [_vm._v("Stäng")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3524ab5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3524ab5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FamilyTree.vue
// module id = null
// module chunks = 